import React from 'react';
import { Box, Drawer, List, ListItem, ListItemIcon, ListItemText, useMediaQuery } from '@mui/material';
import {
  StoreOutlined,
  AssignmentOutlined,
  PersonOutline,
  EmailOutlined,
  AssessmentOutlined,
  DescriptionOutlined,
} from '@mui/icons-material';
import { observer } from "mobx-react-lite";
import { withRouter } from 'react-router';
import { useTheme } from '@mui/material/styles';
import { INTERNAL_HEADER_HEIGHT } from '../../../constants/Constants';
import { NAV_TEXT_STYLE, FOOTER_STYLE } from '../../../constants/Styles';
import Colors from '../../../constants/Colors';
import packageJson from '../../../../package.json';
import MenuStore from '../../../stores/internal/MenuStore';
import { getAdminAccessLevel } from '../../../actions/profile/UserActions';

const DRAWER_WIDTH = 200;

const AdminSidePanel = ({ history }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const isDrawerOpen = MenuStore.isDrawerOpen;
  const userAccessLevel = getAdminAccessLevel();

  const tools = [
    { name: 'Accounts', icon: <StoreOutlined sx={{ color: Colors.primaryColor }} />, link: '/admin/sites', access_level: 0 },
    { name: 'Projects', icon: <AssignmentOutlined sx={{ color: Colors.primaryColor }} />, link: '/admin/projects', access_level: 0 },
    { name: 'Users', icon: <PersonOutline sx={{ color: Colors.primaryColor }} />, link: '/admin/users', access_level: 0 },
    { name: 'Emails', icon: <EmailOutlined sx={{ color: Colors.primaryColor }} />, link: '/admin/email-marketing', access_level: 100 },
    { name: 'Reports', icon: <AssessmentOutlined sx={{ color: Colors.primaryColor }} />, link: '/admin/reports', access_level: 100 },
    { name: 'Summaries', icon: <DescriptionOutlined sx={{ color: Colors.primaryColor }} />, link: '/admin/support-summaries', access_level: 100 }
  ];

  const handleNav = (path) => {
    history.push(path);
    if (isMobile) {
      MenuStore.setIsDrawerOpen(false);
    }
  };

  return (
    <Drawer
      anchor="left"
      variant={isMobile ? 'temporary' : 'permanent'}
      open={isMobile ? isDrawerOpen : true}
      onClose={() => MenuStore.setIsDrawerOpen(false)}
      ModalProps={{ keepMounted: true }}
      sx={{
        width: DRAWER_WIDTH,
        flexShrink: 0,
        zIndex: isMobile ? 1301 : 'auto',
        '& .MuiDrawer-paper': {
          width: DRAWER_WIDTH,
          boxSizing: 'border-box',
          position: 'fixed',
          height: isMobile ? '100vh' : `calc(100vh - ${INTERNAL_HEADER_HEIGHT}px)`,
          top: isMobile ? 0 : INTERNAL_HEADER_HEIGHT,
        },
      }}
    >
      <Box sx={{ display: 'flex', flexDirection: 'column', justifyContent: 'space-between', height: '100%' }}>
        <List>
          {tools.map((tool) => {
            if (userAccessLevel < tool.access_level) return;
            return (
            <ListItem key={tool.name} button onClick={() => handleNav(tool.link)}>
              <ListItemIcon>{tool.icon}</ListItemIcon>
              <ListItemText primary={<span style={{ ...NAV_TEXT_STYLE }}>{tool.name}</span>} />
            </ListItem>)
            }).filter(t => t)}
        </List>
        <Box
          sx={{
            ...FOOTER_STYLE,
            display: 'flex',
            flexDirection: { xs: 'column', sm: 'column', md: 'row' },
            justifyContent: 'space-between',
            zIndex: 1300,
          }}
        >
          <Box
            sx={{
              width: '100%',
              textAlign: {
                xs: 'center',
                sm: 'center',
                md: 'center',
              },
            }}
          >
            Developed by <b>BCK</b>
            <br />
            v.{packageJson.version}
          </Box>
        </Box>
      </Box>
    </Drawer>
  );
};

export default withRouter(observer(AdminSidePanel));
